/* global $ */

// wrap all video functionality in a function so it can be called again when needed after ajax loads new videos
function runVideoFunctions() {
	let currentID = 1;
	$.$body.find('.video-share .videoWrapper iframe').each(function () {
		$(this).attr('id', currentID);
		$(this).attr('src', $(this).attr('src') + '&autoplay=0');
		$(this).attr('src', $(this).attr('src') + '&rel=0');
		currentID++;
	});

	let current = 1;
	$.$body.find('.video-cover').each(function () {
		const findVideo = $('#' + current);
		const vidSrc = $(findVideo).attr('src');
		// console.log(vidSrc);
		if (vidSrc.includes('youtube')) {
			$(this).click(function () {
				$(this).fadeOut();
			});
		} else {
			$(this).click(function () {
				$(this).fadeOut();
				$(findVideo).attr(
					'src',
					$(findVideo).attr('src').replace('autoplay=0', 'autoplay=1')
					// console.log('switching to autoplay')
				);
			});
		}

		current++;
	});

	// fix popover iframes
	$.$body.find('.pop-over .videoWrapper iframe').each(function () {
		$(this).attr('id', currentID);
		$(this).attr('src', $(this).attr('src') + '&autoplay=1');
		$(this).attr('src', $(this).attr('src') + '&rel=0');
		currentID++;
	});

	$(document).on('click touchstart', (event) => {
		if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
			if ($('.pop-over').is(':visible')) {
				$('.pop-over').hide();
				const iFrameSrc = $('.pop-over .videoWrapper iframe').attr(
					'src'
				);
				if (iFrameSrc) {
					$('.pop-over .videoWrapper iframe').attr(
						'src',
						iFrameSrc.replace('autoplay=1', 'autoplay=0')
					);
				}
			}
		}
	});

	$.$body.find('.play-button').click((event) => {
		if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
			if ($('.pop-over').is(':visible')) {
				$('.pop-over').hide();
			}
		}
	});

	// prevent ambient video from being played by default, saving data.
	function playVideo($video) {
		$video
			.prop('autoplay', true)
			.attr('preload', 'auto')
			.removeClass('unplayed');
		const video = $video.get(0);
		if (video && typeof video.play === 'function') {
			video.play();
		}
	}

	const $videos = $('body').find('video');
	function playVideosIfVisible() {
		if ($videos.filter('.unplayed').length) {
			$('body')
				.find('video')
				.filter('.unplayed')
				.each((i, el) => {
					const $video = $(el);
					if ($video.css('display') === 'block') {
						playVideo($video);
					}
				});
		} else {
			$(window).off('resize', playVideosIfVisible);
		}
	}

	if ($videos.length) {
		$(window).resize(playVideosIfVisible);
		playVideosIfVisible();
	}

	// YT iframe play via postMessage on button click
	const iframeObjects = document.querySelectorAll('.videoWrapper iframe');
	// console.log(iframeObjects);

	iframeObjects.forEach((scopediframeObject) => {
		// console.log(scopediframeObject);
		const playButton = scopediframeObject.parentElement.querySelector(
			'.play-button'
		);
		// console.log(playButton);
		playButton.addEventListener('click', () => {
			const targetWindow = scopediframeObject.contentWindow;
			// console.log(targetWindow);
			// console.log('playing ' + scopediframeObject.id);
			targetWindow.postMessage(
				JSON.stringify({
					event: 'command',
					func: 'playVideo',
					args: [],
				}),
				'*'
			);
		});
	});
}
// run the video functions after page load
runVideoFunctions();

// set up mutation observer if the ajax #results container is present
if (document.querySelector('#results')) {
	const mutationObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			// console.log(mutation.addedNodes);
			// if there is a change in the observed wrapper and new nodes, call the video functions again
			if (mutation.addedNodes.length) {
				// console.log(mutation);
				// console.log('new nodes');
				runVideoFunctions();
			}
		});
	});
	// Starts listening for changes in the root HTML element of the page.
	mutationObserver.observe(document.querySelector('#results'), {
		// attributes: true,
		// characterData: true,
		childList: true,
		// subtree: true,
		// attributeOldValue: true,
		// characterDataOldValue: true,
	});
}
